import React from 'react';
import logoBlack from '../../../assets/logo-noir.png';

import CONFIG from '../../../config';
import WidgetInputText from '../../../components/widgets/WidgetInputText';

import Button from '@mui/material/Button';
import Link from '@mui/material/Link';


function Deconnexion() {
    localStorage.setItem('token', '');
    const [done, setDone] = React.useState(localStorage.getItem('token') === '');


    return (
        <>
            <div className='m-6 grid grid-cols-12 gap-x-4 shrink-0 p-6 max-w-lg mx-auto bg-white my-shadow'>
                <div className='col-start-3 col-span-8 w-full item-center mb-6'>
                    <img src={logoBlack} alt="Logo" />
                </div>

                <div className='col-span-12 w-full mb-4 text-center'>
                    <h1>Deconnexion</h1>
                </div>

                {done &&
                    <div className='col-start-2 col-span-10 w-full text-center text-sm bg-green-200 rounded-md p-2'>
                        Vous avez été déconnecté. Vous pouvez <Link variant='contained' href={CONFIG.BASE_URL + "/connexion"}><span className='text-black underline decoration-black hover:decoration-2'>cliquer ici</span></Link> pour vous reconnecter.
                    </div>
                }

                {!done &&
                    <div className='col-start-2 col-span-10 w-full text-center text-sm bg-red-200 rounded-md p-2'>
                        Il y a eu un problème, vous n'avez pas été déconnecté.
                    </div>
                }
            </div>
        </>
    );
}

export default Deconnexion;